/**
 * Web-specific implementation of the fretboard config store.
 * Uses localStorage for persistence.
 */

import { createJSONStorage } from 'zustand/middleware';
import { AccidentalPreference, createFretboardConfigStore } from '@fretgenius/ui';
import { isMobile } from 'react-device-detect';
import { reportError } from '@/utils/errorReporting';

/**
 * Web implementation of the fretboard configuration store.
 * Uses localStorage for persistence.
 */
export const useFretboardConfigStore = createFretboardConfigStore(
  {
    storage: createJSONStorage(() => localStorage),
    reportErrorFn: reportError,
  },
  {
    heightRatio: isMobile ? 1 : 0.4,
    showFretMarkerLabels: false,
    accidentalPreference: AccidentalPreference.Flat,
    fretWidthBase: isMobile ? 20 : 35,
    isLeftHanded: false,
    noteCircleScale: isMobile ? 1 : 0.8,
    numFrets: isMobile ? 12 : 24,
    useEqualTemperament: true,
    useTrapezoidScaling: true,
  }
);
